import { gql } from '@apollo/client'

export const reorderGalleryCollectionImagesMutation = gql`
  mutation ReorderGalleryCollectionImages($records: [GalleryCollectionImageIndexChangeInput!]!) {
    reorderGalleryCollectionImages(galleryCollectionsImages: $records)
  }
`
